/**
 * @generated SignedSource<<90c7134b8e0d5844cc9109ee1b69d0dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventDatetimeFormFields_Occurrence$data = {
  readonly datetimeRange: ReadonlyArray<string>;
  readonly timezone: string;
  readonly " $fragmentType": "EventDatetimeFormFields_Occurrence";
};
export type EventDatetimeFormFields_Occurrence$key = {
  readonly " $data"?: EventDatetimeFormFields_Occurrence$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDatetimeFormFields_Occurrence">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDatetimeFormFields_Occurrence",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datetimeRange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};

(node as any).hash = "74f9e4a54f4c0a312bd6d37c8c2261c4";

export default node;
